module.exports = __webpack_public_path__ + "img/consultoria_16-9_2880.174e9ddc.webp";